var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDozer = function SvgDozer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8213 68.6084H47.2617V70.708H44.5215V68.6084H37.8848V70.708H35.1445V68.6084H28.5078V70.708H25.7676V68.6084H24.0391V59.5254H48.8213V68.6084Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.832 7.62207H55.4619V48.5771H53.1543V59.1953H44.1953C43.9517 59.3961 43.6392 59.5166 43.2979 59.5166H29.0557C28.7149 59.5166 28.4029 59.3959 28.1592 59.1953H19.0488V48.5771H16.7285V7.62207H15.168V2.30469H56.832V7.62207ZM20.3682 15.5742H29.127V14.9033C28.8445 14.5644 28.6739 14.129 28.6738 13.6533V7.62207H20.3682V15.5742ZM43.6582 13.6533C43.6577 14.1527 43.4681 14.6066 43.1602 14.9521V15.5742H51.8223V7.62207H43.6582V13.6533Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14804_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.08 -76.2588H-387.963V185.662H272.08V-76.2588Z",
    stroke: "black",
    strokeWidth: 3.67092
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3742 16.4164H30.3011C29.2211 16.4164 28.3457 15.5409 28.3457 14.4609V7.72983C28.3457 6.6507 29.2203 5.77441 30.3011 5.77441H41.3742C42.4542 5.77441 43.3296 6.64983 43.3296 7.72983V14.4609C43.3287 15.5409 42.4542 16.4164 41.3742 16.4164Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3583 58.0977H31.1836V35.3229C32.1556 34.8093 32.8194 33.7898 32.8194 32.6141V11.0045C32.8194 10.7937 32.7975 10.5856 32.7562 10.3872H38.8718C38.8305 10.5865 38.8086 10.7937 38.8086 11.0045V32.6141C38.8086 33.7547 39.4346 34.7478 40.3592 35.2746V58.0977H40.3583Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1209 17.4165H19.7539V58.9684H28.1209V17.4165Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 2.06918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 22.7368H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 20.4277H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 18.8306H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 57.4663H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 55.8691H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 53.1104H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 50.0732H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 47.0361H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 43.998H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 40.9609H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 37.9233H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 34.8862H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 31.8481H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 28.811H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 25.7739H27.5699",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7906 17.4165H43.4219V58.9684H51.7906V17.4165Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 2.06918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 22.7368H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 20.4277H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 18.8306H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 57.4663H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 55.8691H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 53.1104H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 50.0732H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 47.0361H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 43.998H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 40.9609H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 37.9233H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 34.8862H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 31.8481H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 28.811H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9492 25.7739H51.2379",
    stroke: "#C68106",
    strokeWidth: 0.959198
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7578 32.6137V11.0049",
    stroke: "black",
    strokeWidth: 1.92069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8711 32.6137V11.0049",
    stroke: "black",
    strokeWidth: 1.92069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5009 20.8149H29.1309V25.5599H42.5009V20.8149Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7476 16.924C40.7476 16.5763 40.5044 16.2944 40.2023 16.2944H31.4183C31.1163 16.2944 30.873 16.5763 30.873 16.924V35.5061C30.873 35.8538 31.1163 36.1357 31.4183 36.1357H40.2023C40.5044 36.1357 40.7476 35.8538 40.7476 35.5061V16.924Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 0.640256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8279 56.9049C46.8279 57.2061 46.5847 57.4502 46.2826 57.4502H25.2367C24.9346 57.4502 24.6914 57.2061 24.6914 56.9049V44.8695C24.6914 44.5683 24.9346 44.3242 25.2367 44.3242H46.2826C46.5847 44.3242 46.8279 44.5683 46.8279 44.8695V56.9049Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 0.640256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3848 39.4817V57.6845C26.3848 58.3782 26.9476 58.941 27.6421 58.941H44.0555C44.75 58.941 45.3129 58.3782 45.3129 57.6845V39.4817L41.1834 33.7173H30.5151L26.3848 39.4817Z",
    fill: "#BDBDBD",
    stroke: "black",
    strokeWidth: 0.640256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7007 18.9236H30.9219V16.8637C30.9219 16.8637 30.9684 16.3579 31.3715 16.3579C31.7745 16.3579 40.2239 16.3579 40.2239 16.3579C40.2239 16.3579 40.7192 16.3579 40.7192 16.9295C40.7192 17.5011 40.7007 18.9236 40.7007 18.9236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6367 43.118V58.9141C27.6367 59.5164 28.124 60.0046 28.7272 60.0046H42.9701C43.5742 60.0046 44.0606 59.5164 44.0606 58.9141V43.118L40.4782 38.1157H31.2191L27.6367 43.118Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 0.640256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2991 38.2363L27.7676 43.1683V55.1941H43.9641V43.1991L40.4018 38.2671L31.2991 38.2363Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5156 33.8174L31.2189 38.1154",
    stroke: "black",
    strokeWidth: 1.03459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.498 38.039L41.1829 33.7173",
    stroke: "black",
    strokeWidth: 1.03459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3126 39.4814L44.0605 43.1183",
    stroke: "black",
    strokeWidth: 0.640256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6369 43.1183L26.3848 39.4814",
    stroke: "black",
    strokeWidth: 0.640256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5838 36.2999C40.5838 35.7783 40.0947 35.356 39.4932 35.356H32.237C31.6347 35.356 31.1465 35.7783 31.1465 36.2999V38.1288C31.1465 38.6504 31.6356 39.0736 32.237 39.0736H39.4932C40.0956 39.0736 40.5838 38.6504 40.5838 38.1288V36.2999Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 0.962833
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5041 3.1123H14.8398V8.43065H56.5041V3.1123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3719 7.73047H30.2988V14.4616H41.3719V7.73047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6169 8.43066H52.0117V48.8674H54.6169V8.43066Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.03459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5231 8.43066H16.918V48.8674H19.5231V8.43066Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.03459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6651 61.1611H24.5391V68.5885H47.6651V61.1611Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.65532
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5568 68.561H34.8164V71.5165H37.5568V68.561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9338 68.561H44.1934V71.5165H46.9338V68.561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1798 68.561H25.4395V71.5165H28.1798V68.561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6319 60.8716H28.7422V67.3156H31.6319V60.8716Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1182 60.8716H40.2285V67.3156H43.1182V60.8716Z",
    fill: "#C68106"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14804_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5366,
    height: 72,
    fill: "white",
    transform: "translate(12.2324 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDozer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dozer.7f13a2fec05f00f66787814f750273b6.svg";